import { UserDefinedMaintenancePage } from "@/components/specific/userDefined";
import { UserDefinedItemType } from "@/types/domain";

export const ProjectUserDefinedMaintenancePage = () => {
  return (
    <UserDefinedMaintenancePage
      itemType={UserDefinedItemType.Project}
      entityType="UserDefProject"
      title="Project User Defined Items"
      cacheKey="project_user_defined_sort"
    />
  );
};